export const useAssessmentKey = {
  base: ["assessment"] as const,
  detail: (assessmentId: string) => [...useAssessmentKey.base, assessmentId] as const,
};
